// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WUEO","select":"styles_select__1z3KL"};